var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploaddocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443.281,
    height: 449.376,
    viewBox: "0 0 443.281 449.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uploaddocument",
    transform: "translate(-154.582 -12.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8312",
    "data-name": "Group 8312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8250",
    "data-name": "Group 8250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8195",
    "data-name": "Group 8195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8047",
    "data-name": "Group 8047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8046",
    "data-name": "Group 8046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8045",
    "data-name": "Group 8045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8028",
    "data-name": "Group 8028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8027",
    "data-name": "Group 8027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8026",
    "data-name": "Group 8026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8025",
    "data-name": "Group 8025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8024",
    "data-name": "Group 8024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8023",
    "data-name": "Group 8023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8022",
    "data-name": "Group 8022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8021",
    "data-name": "Group 8021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8020",
    "data-name": "Group 8020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8019",
    "data-name": "Group 8019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8018",
    "data-name": "Group 8018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8017",
    "data-name": "Group 8017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8016",
    "data-name": "Group 8016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8015",
    "data-name": "Group 8015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8014",
    "data-name": "Group 8014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8013",
    "data-name": "Group 8013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5828",
    "data-name": "Path 5828",
    d: "M328.362,131.983,327.09,234.394c-.217,17.416,3.024,43.043,30.575,42.13h0c23.844-2.6,30.169-25.168,30.355-41.42.087-7.709.177-14.138.238-14.93,0,0,26.1-2.128,28.3-27.909,1.065-12.458,1.168-38.3.991-61.674a48.2,48.2,0,0,0-44.7-47.675l-2.489-.181C343.4,82.342,328.008,105.021,328.362,131.983Z",
    fill: "#ffbe9d"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8044",
    "data-name": "Group 8044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8043",
    "data-name": "Group 8043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8042",
    "data-name": "Group 8042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8041",
    "data-name": "Group 8041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8040",
    "data-name": "Group 8040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8039",
    "data-name": "Group 8039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8038",
    "data-name": "Group 8038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8037",
    "data-name": "Group 8037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8036",
    "data-name": "Group 8036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8035",
    "data-name": "Group 8035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8034",
    "data-name": "Group 8034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8033",
    "data-name": "Group 8033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8032",
    "data-name": "Group 8032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8031",
    "data-name": "Group 8031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8030",
    "data-name": "Group 8030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8029",
    "data-name": "Group 8029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5829",
    "data-name": "Path 5829",
    d: "M388.258,220.174s-16.335-.234-32.872-12.386c0,0,6.819,19.446,32.737,19Z",
    fill: "#eb996e"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8136",
    "data-name": "Group 8136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8135",
    "data-name": "Group 8135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8102",
    "data-name": "Group 8102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8101",
    "data-name": "Group 8101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8100",
    "data-name": "Group 8100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8065",
    "data-name": "Group 8065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8064",
    "data-name": "Group 8064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8063",
    "data-name": "Group 8063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8062",
    "data-name": "Group 8062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8061",
    "data-name": "Group 8061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8060",
    "data-name": "Group 8060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8059",
    "data-name": "Group 8059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8058",
    "data-name": "Group 8058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8057",
    "data-name": "Group 8057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8056",
    "data-name": "Group 8056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8055",
    "data-name": "Group 8055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8054",
    "data-name": "Group 8054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8053",
    "data-name": "Group 8053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8052",
    "data-name": "Group 8052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8051",
    "data-name": "Group 8051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8050",
    "data-name": "Group 8050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8049",
    "data-name": "Group 8049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8048",
    "data-name": "Group 8048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5830",
    "data-name": "Path 5830",
    d: "M373.477,141.155c-.513.522-3.489-1.875-7.809-1.99-4.313-.181-7.545,2-8,1.447-.224-.248.31-1.2,1.718-2.189a10.8,10.8,0,0,1,6.421-1.822,10.423,10.423,0,0,1,6.2,2.255C373.3,139.939,373.728,140.923,373.477,141.155Z",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8082",
    "data-name": "Group 8082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8081",
    "data-name": "Group 8081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8080",
    "data-name": "Group 8080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8079",
    "data-name": "Group 8079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8078",
    "data-name": "Group 8078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8077",
    "data-name": "Group 8077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8076",
    "data-name": "Group 8076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8075",
    "data-name": "Group 8075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8074",
    "data-name": "Group 8074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8073",
    "data-name": "Group 8073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8072",
    "data-name": "Group 8072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8071",
    "data-name": "Group 8071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8070",
    "data-name": "Group 8070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8069",
    "data-name": "Group 8069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8068",
    "data-name": "Group 8068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8067",
    "data-name": "Group 8067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8066",
    "data-name": "Group 8066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5831",
    "data-name": "Path 5831",
    d: "M372.567,150.089a3.5,3.5,0,0,1-3.618,3.272,3.343,3.343,0,0,1-3.363-3.406,3.5,3.5,0,0,1,3.614-3.273A3.345,3.345,0,0,1,372.567,150.089Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8099",
    "data-name": "Group 8099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8098",
    "data-name": "Group 8098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8097",
    "data-name": "Group 8097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8096",
    "data-name": "Group 8096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8095",
    "data-name": "Group 8095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8094",
    "data-name": "Group 8094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8093",
    "data-name": "Group 8093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8092",
    "data-name": "Group 8092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8091",
    "data-name": "Group 8091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8090",
    "data-name": "Group 8090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8089",
    "data-name": "Group 8089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8088",
    "data-name": "Group 8088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8087",
    "data-name": "Group 8087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8086",
    "data-name": "Group 8086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8085",
    "data-name": "Group 8085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8084",
    "data-name": "Group 8084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8083",
    "data-name": "Group 8083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5832",
    "data-name": "Path 5832",
    d: "M384.3,171.2c0-.226,2.493-.473,6.525-.691,1.02-.031,1.993-.162,2.214-.841.292-.714-.052-1.836-.457-3.05q-1.16-3.78-2.431-7.929c-3.357-11.282-5.708-20.528-5.253-20.659s3.547,8.906,6.9,20.187q1.206,4.171,2.3,7.966c.3,1.179.862,2.533.234,4.013a2.546,2.546,0,0,1-1.772,1.358,6.864,6.864,0,0,1-1.738.114C386.79,171.592,384.3,171.428,384.3,171.2Z",
    fill: "#263238"
  }))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8118",
    "data-name": "Group 8118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8117",
    "data-name": "Group 8117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8116",
    "data-name": "Group 8116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8115",
    "data-name": "Group 8115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8114",
    "data-name": "Group 8114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8113",
    "data-name": "Group 8113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8112",
    "data-name": "Group 8112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8111",
    "data-name": "Group 8111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8110",
    "data-name": "Group 8110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8109",
    "data-name": "Group 8109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8108",
    "data-name": "Group 8108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8107",
    "data-name": "Group 8107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8106",
    "data-name": "Group 8106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8105",
    "data-name": "Group 8105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8104",
    "data-name": "Group 8104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8103",
    "data-name": "Group 8103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5833",
    "data-name": "Path 5833",
    d: "M371.639,124.916c-.417.958-3.875.237-8.015.449-4.145.125-7.545,1.126-8.025.205-.212-.441.433-1.323,1.84-2.178a13.066,13.066,0,0,1,6.062-1.705,12.926,12.926,0,0,1,6.158,1.208C371.12,123.632,371.821,124.46,371.639,124.916Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8134",
    "data-name": "Group 8134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8133",
    "data-name": "Group 8133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8132",
    "data-name": "Group 8132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8131",
    "data-name": "Group 8131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8130",
    "data-name": "Group 8130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8129",
    "data-name": "Group 8129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8128",
    "data-name": "Group 8128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8127",
    "data-name": "Group 8127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8126",
    "data-name": "Group 8126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8125",
    "data-name": "Group 8125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8124",
    "data-name": "Group 8124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8123",
    "data-name": "Group 8123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8122",
    "data-name": "Group 8122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8121",
    "data-name": "Group 8121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8120",
    "data-name": "Group 8120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8119",
    "data-name": "Group 8119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5834",
    "data-name": "Path 5834",
    d: "M412.661,132.92c-.453.781-3.824-.086-7.908-.212-4.085-.2-7.475.4-7.906-.42-.189-.389.484-1.089,1.908-1.709a14.262,14.262,0,0,1,6.041-1,14.745,14.745,0,0,1,6.007,1.48C412.207,131.793,412.861,132.546,412.661,132.92Z",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8150",
    "data-name": "Group 8150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8149",
    "data-name": "Group 8149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8148",
    "data-name": "Group 8148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8147",
    "data-name": "Group 8147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8146",
    "data-name": "Group 8146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8145",
    "data-name": "Group 8145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8144",
    "data-name": "Group 8144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8143",
    "data-name": "Group 8143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8142",
    "data-name": "Group 8142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8141",
    "data-name": "Group 8141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8140",
    "data-name": "Group 8140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8139",
    "data-name": "Group 8139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8138",
    "data-name": "Group 8138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8137",
    "data-name": "Group 8137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5835",
    "data-name": "Path 5835",
    d: "M329.074,151.243c-.426-.223-17.347-6.539-18.071,11.143s17.177,14.763,17.228,14.257S329.074,151.243,329.074,151.243Z",
    fill: "#ffbe9d"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8165",
    "data-name": "Group 8165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8164",
    "data-name": "Group 8164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8163",
    "data-name": "Group 8163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8162",
    "data-name": "Group 8162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8161",
    "data-name": "Group 8161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8160",
    "data-name": "Group 8160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8159",
    "data-name": "Group 8159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8158",
    "data-name": "Group 8158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8157",
    "data-name": "Group 8157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8156",
    "data-name": "Group 8156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8155",
    "data-name": "Group 8155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8154",
    "data-name": "Group 8154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8153",
    "data-name": "Group 8153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8152",
    "data-name": "Group 8152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8151",
    "data-name": "Group 8151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5836",
    "data-name": "Path 5836",
    d: "M323.105,169.722c-.076-.059-.318.2-.848.421a3.083,3.083,0,0,1-2.3-.047c-1.84-.763-3.291-3.793-3.247-6.983a10.2,10.2,0,0,1,1.043-4.375,3.56,3.56,0,0,1,2.414-2.269,1.568,1.568,0,0,1,1.783.918c.217.5.09.853.183.887.048.046.392-.28.279-1.017a1.968,1.968,0,0,0-.65-1.136,2.331,2.331,0,0,0-1.685-.52,4.329,4.329,0,0,0-3.33,2.61,10.459,10.459,0,0,0-1.27,4.884c-.033,3.568,1.655,6.977,4.18,7.821a3.3,3.3,0,0,0,2.836-.353C323.055,170.149,323.164,169.757,323.105,169.722Z",
    fill: "#eb996e"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8167",
    "data-name": "Group 8167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8166",
    "data-name": "Group 8166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5837",
    "data-name": "Path 5837",
    d: "M380.124,183.444c.193-.447-3.271-1.484-5.706-4.734a19.815,19.815,0,0,1-2.447-4.618c-.516-1.283-.907-2.089-1.1-2.03s-.135.925.149,2.322a13.056,13.056,0,0,0,2.275,5.172,10.576,10.576,0,0,0,4.517,3.458C379.164,183.561,380.078,183.6,380.124,183.444Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8169",
    "data-name": "Group 8169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8168",
    "data-name": "Group 8168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5838",
    "data-name": "Path 5838",
    d: "M451.789,107.448a4.176,4.176,0,0,0-1.961-2.438c-2.019-1.192-4.344-1.034-6.591-1.07a37.23,37.23,0,0,1-19.388-5.893,86.808,86.808,0,0,0-9.023-10.934c-7.814-8.058-14.245-13.542-20.895-16.219-8.6-3.463-22.992-4.867-31.961-2.514S344.943,78.012,343.7,87.2c-5.03-4.254-12.583-4.218-18.709-1.754l-.154-.067c-6.824,2.432-10.7,9.641-12.713,16.6s-2.872,14.4-6.557,20.636c-.771,1.3-1.686,2.867-1.013,4.224a2.878,2.878,0,0,0,3.012,1.312,8.447,8.447,0,0,0,3.177-1.438l-2.283,5.467a16.128,16.128,0,0,0,7.422-.5c1.45,6.508,3.177,13.939,4.854,18.349,2.852-.008,5.463.2,7.221,1.778,2.39,2.148,3.459,6.191,7.43,4.656,2.021-.781,3.866-5.021,4.542-7.08a100.614,100.614,0,0,0,4.357-42.591,32.343,32.343,0,0,1,9.987-7.208l-.305.275c7.205-2.5,15.355-4.964,22.191-1.582,5.3,2.624,8.42,8.126,12.384,12.517a40.479,40.479,0,0,0,28.85,13.326c.381,7.259-.229,17.52.152,24.779l6.107-11.629.005.058c.5-.85.914-1.709,1.313-2.569l.138-.261v-.032a45.544,45.544,0,0,1,2.042-4.13l.07.062c3.933,3.47,9.729-1.836,6.627-6.065a10.254,10.254,0,0,0-2.193-2.2,7.175,7.175,0,0,0,6.835,1.772,5.628,5.628,0,0,0,3.981-5.567,4.787,4.787,0,0,0-2.853-3.84,16.172,16.172,0,0,0,9.2-2.027C450.623,111.437,452.4,109.732,451.789,107.448Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8171",
    "data-name": "Group 8171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8170",
    "data-name": "Group 8170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5839",
    "data-name": "Path 5839",
    d: "M351.812,90.162a22.3,22.3,0,0,0-2.587,2.366,18.491,18.491,0,0,0-3.958,8.563,32.444,32.444,0,0,0-.659,6.554c-.011,2.375.18,4.918.362,7.6a68,68,0,0,1,.193,8.457,29.794,29.794,0,0,1-.581,4.462,9.3,9.3,0,0,1-1.82,4.327,3.893,3.893,0,0,1-3.639,1.224,5.8,5.8,0,0,1-3.275-1.85c-1.66-1.937-2.073-4.393-2.486-6.558l.542.066a21.6,21.6,0,0,1-3.138,5.4,7.681,7.681,0,0,1-5.017,2.732,4.968,4.968,0,0,1-2.659-.466,4.288,4.288,0,0,1-1.806-1.779,4.426,4.426,0,0,1-.548-2.287,3.209,3.209,0,0,1,.828-2l.274.244a16.644,16.644,0,0,1-5.54,4.156,15.088,15.088,0,0,1-1.717.667,2.805,2.805,0,0,1-.615.152,3.118,3.118,0,0,1,.582-.248c.383-.157.953-.387,1.664-.748a17.149,17.149,0,0,0,5.347-4.218l.274.244a3.305,3.305,0,0,0-.171,3.832,3.857,3.857,0,0,0,1.633,1.575,4.5,4.5,0,0,0,2.41.392,7.2,7.2,0,0,0,4.657-2.6,21.288,21.288,0,0,0,3.021-5.286l.371-.828.171.893c.413,2.162.853,4.52,2.366,6.266a5.215,5.215,0,0,0,2.931,1.654,3.284,3.284,0,0,0,3.094-1.036,8.806,8.806,0,0,0,1.68-4.049,29.549,29.549,0,0,0,.578-4.37,69,69,0,0,0-.159-8.386c-.166-2.679-.34-5.234-.307-7.639a32.347,32.347,0,0,1,.742-6.64,18.242,18.242,0,0,1,4.2-8.629A10.486,10.486,0,0,1,351.812,90.162Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8173",
    "data-name": "Group 8173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8172",
    "data-name": "Group 8172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5840",
    "data-name": "Path 5840",
    d: "M431.593,115.255c.006.008-.064.068-.207.177l-.645.469a8.552,8.552,0,0,1-1.092.7,13.968,13.968,0,0,1-1.569.826,22.884,22.884,0,0,1-11.038,1.986,29.228,29.228,0,0,1-15.565-5.748c-5.153-3.705-9.674-9.162-13.371-15.412-1.876-3.123-3.4-6.324-5.09-9.281a34.184,34.184,0,0,0-5.763-7.851,17.606,17.606,0,0,0-7.431-4.51,12.621,12.621,0,0,0-3.919-.451,13.871,13.871,0,0,0-3.588.689,14.926,14.926,0,0,0-8.287,7.012,17.869,17.869,0,0,0-1.331,3.867.921.921,0,0,1,.021-.27l.122-.79a12.891,12.891,0,0,1,.979-2.912,14.671,14.671,0,0,1,2.887-3.914,15.088,15.088,0,0,1,5.471-3.4,14.183,14.183,0,0,1,3.7-.751,13.047,13.047,0,0,1,4.076.434,18.039,18.039,0,0,1,7.685,4.593,34.485,34.485,0,0,1,5.889,7.958c1.706,2.978,3.236,6.171,5.1,9.265,3.669,6.2,8.125,11.6,13.18,15.27a29.04,29.04,0,0,0,15.264,5.772,23.223,23.223,0,0,0,10.915-1.774A36.34,36.34,0,0,0,431.593,115.255Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8175",
    "data-name": "Group 8175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8174",
    "data-name": "Group 8174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5841",
    "data-name": "Path 5841",
    d: "M433.94,103.923a4.03,4.03,0,0,1-.925.644,20.02,20.02,0,0,1-2.739,1.391,26.66,26.66,0,0,1-4.336,1.424,28.077,28.077,0,0,1-11.127.356,26.725,26.725,0,0,1-4.419-1.143,20.038,20.038,0,0,1-2.822-1.213,4.077,4.077,0,0,1-.964-.583c.05-.1,1.475.63,3.92,1.391a30.539,30.539,0,0,0,4.372,1,30.123,30.123,0,0,0,10.918-.35,30.449,30.449,0,0,0,4.3-1.278C432.508,104.647,433.883,103.825,433.94,103.923Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8185",
    "data-name": "Group 8185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8184",
    "data-name": "Group 8184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8183",
    "data-name": "Group 8183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8182",
    "data-name": "Group 8182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8181",
    "data-name": "Group 8181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8180",
    "data-name": "Group 8180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8179",
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8178",
    "data-name": "Group 8178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8177",
    "data-name": "Group 8177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8176",
    "data-name": "Group 8176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5842",
    "data-name": "Path 5842",
    d: "M412.854,142.782c-.513.522-3.489-1.875-7.809-1.991-4.313-.18-7.545,2-8,1.448-.224-.248.31-1.2,1.718-2.189a10.805,10.805,0,0,1,6.421-1.822,10.429,10.429,0,0,1,6.2,2.254C412.682,141.566,413.105,142.55,412.854,142.782Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8194",
    "data-name": "Group 8194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8193",
    "data-name": "Group 8193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8192",
    "data-name": "Group 8192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8191",
    "data-name": "Group 8191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8190",
    "data-name": "Group 8190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8189",
    "data-name": "Group 8189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8188",
    "data-name": "Group 8188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8187",
    "data-name": "Group 8187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8186",
    "data-name": "Group 8186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5843",
    "data-name": "Path 5843",
    d: "M408.451,151.344a3.5,3.5,0,0,1-3.618,3.271,3.342,3.342,0,0,1-3.363-3.4,3.5,3.5,0,0,1,3.615-3.274A3.346,3.346,0,0,1,408.451,151.344Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8196",
    "data-name": "Group 8196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5844",
    "data-name": "Path 5844",
    d: "M569.556,245.631c0-7.491-7.158-7.491-7.158-7.491-2.727-3.583-5.795-2.28-5.795-2.28l-11.59,7.817c-1.705,2.931-12.954,14.006-12.954,14.006-3.068-2.28-3.068-6.84-6.745-12.378s-12-4.885-12-4.885,6.477,14.657,7.159,23.777-4.979,34.559-4.979,34.559l32.767,9.209s2.068-13.955,5.74-15.082c4.419-1.356,6.879-7.876,6.879-7.876,4.777-9.677,14.475-23.741,15.839-30.907S569.556,245.631,569.556,245.631Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8221",
    "data-name": "Group 8221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8203",
    "data-name": "Group 8203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8197",
    "data-name": "Group 8197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5845",
    "data-name": "Path 5845",
    d: "M325.885,229.433c20.87,13.115,41.9,18.049,63.207,9.555l32.023,8.18L452.62,457.66,267.9,459.265l9.1-48.89L299.9,234.72Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8198",
    "data-name": "Group 8198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5846",
    "data-name": "Path 5846",
    d: "M421.115,247.168s24.906,10.342,34.412,28.459S480.311,344.6,480.311,344.6l28.143-51.683,52.231,13.352s-38.878,107.237-48.638,117c-10.686,10.688-39.806,21.465-54.065,13.148s-17.16-39.889-17.16-39.889Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8200",
    "data-name": "Group 8200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8199",
    "data-name": "Group 8199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5847",
    "data-name": "Path 5847",
    d: "M422.832,335.208c-.144,0-.26-9.349-.26-20.879s.116-20.882.26-20.882.26,9.347.26,20.882S422.976,335.208,422.832,335.208Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8202",
    "data-name": "Group 8202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8201",
    "data-name": "Group 8201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5848",
    "data-name": "Path 5848",
    d: "M432.583,259.2a31.245,31.245,0,0,1-1.216,3.449c-.783,2.114-1.825,5.047-2.843,8.331s-1.813,6.294-2.361,8.481a31.55,31.55,0,0,1-.945,3.532,3.566,3.566,0,0,1,.1-.981c.094-.626.26-1.526.489-2.633.458-2.215,1.2-5.253,2.223-8.553s2.124-6.226,3-8.312c.436-1.043.807-1.88,1.084-2.449A3.631,3.631,0,0,1,432.583,259.2Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8220",
    "data-name": "Group 8220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8204",
    "data-name": "Group 8204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5849",
    "data-name": "Path 5849",
    d: "M296.519,313.544l5.779-79.313s-43.479,4.034-57.868,34.709C232.3,294.79,198.836,372.564,195.253,383.2c-10.512,31.22,5.91,74.143,73.612,71.656l7.719-42.443Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8206",
    "data-name": "Group 8206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8205",
    "data-name": "Group 8205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5850",
    "data-name": "Path 5850",
    d: "M247.834,421.265a4.956,4.956,0,0,1,.354-.761l1.1-2.135,4.147-7.8,1.385-2.582a7.647,7.647,0,0,1,1.989-2.555,5.4,5.4,0,0,1,3.343-.962,15.226,15.226,0,0,1,3.6.584,37.027,37.027,0,0,1,7.276,2.751,19.347,19.347,0,0,1,3.493,2.226l.4.35a1.3,1.3,0,0,1,.341.537,4.471,4.471,0,0,1,.221,1.092,17.036,17.036,0,0,1,.047,2.154c-.106,2.867-.462,5.63-.819,8.295s-.773,5.222-1.181,7.656c-.818,4.868-1.636,9.236-2.338,12.9l-1.7,8.671q-.291,1.48-.464,2.356a6.688,6.688,0,0,1-.175.821,4.1,4.1,0,0,1,.071-.837c.072-.546.2-1.347.369-2.376.371-2.106.894-5.066,1.536-8.7.655-3.672,1.436-8.045,2.227-12.912.394-2.433.79-4.991,1.149-7.647s.7-5.416.8-8.241a16.784,16.784,0,0,0-.045-2.086,4.05,4.05,0,0,0-.189-.963.766.766,0,0,0-.206-.337l-.383-.334a18.944,18.944,0,0,0-3.395-2.17,36.99,36.99,0,0,0-7.164-2.741,14.88,14.88,0,0,0-3.489-.59,4.975,4.975,0,0,0-3.08.851,7.287,7.287,0,0,0-1.894,2.4l-1.414,2.563c-1.793,3.228-3.253,5.855-4.292,7.724l-1.19,2.088A5.031,5.031,0,0,1,247.834,421.265Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8208",
    "data-name": "Group 8208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8207",
    "data-name": "Group 8207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5851",
    "data-name": "Path 5851",
    d: "M216.393,383.588a1.906,1.906,0,0,1,.511-.017l1.46.056c1.266.062,3.1.17,5.358.379a69.363,69.363,0,0,1,7.9,1.15,40.41,40.41,0,0,1,9.287,3.077,36.384,36.384,0,0,1,8.17,5.39,21.83,21.83,0,0,1,4.96,6.268,13.87,13.87,0,0,1,1.5,5.172,9.214,9.214,0,0,1,.029,1.466,1.832,1.832,0,0,1-.043.509c-.057,0-.037-.706-.187-1.953a14.592,14.592,0,0,0-1.629-5.026,22.1,22.1,0,0,0-4.952-6.077,37.087,37.087,0,0,0-8.079-5.281,41.378,41.378,0,0,0-9.16-3.076,76.829,76.829,0,0,0-7.833-1.252c-2.248-.256-4.074-.42-5.335-.544l-1.452-.153A1.884,1.884,0,0,1,216.393,383.588Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8210",
    "data-name": "Group 8210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8209",
    "data-name": "Group 8209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5852",
    "data-name": "Path 5852",
    d: "M262.916,379.583a18.774,18.774,0,0,1-1.081,3.121c-.745,1.9-1.854,4.488-3.127,7.323l-3.264,7.254a23.164,23.164,0,0,1-1.42,2.978,18.7,18.7,0,0,1,1.081-3.121c.744-1.9,1.854-4.488,3.127-7.324,1.243-2.761,2.366-5.258,3.263-7.252A23.135,23.135,0,0,1,262.916,379.583Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8212",
    "data-name": "Group 8212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8211",
    "data-name": "Group 8211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5853",
    "data-name": "Path 5853",
    d: "M286.977,317.16c-.144,0-.26-5.027-.26-11.227s.116-11.229.26-11.229.26,5.027.26,11.229S287.121,317.16,286.977,317.16Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8214",
    "data-name": "Group 8214",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8213",
    "data-name": "Group 8213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5854",
    "data-name": "Path 5854",
    d: "M255.525,407.038c-11.438,3.99-19.171,14.369-22.294,26.073-.327,1.227-.546,2.677.275,3.646a2.879,2.879,0,0,0,3.591.294,8.387,8.387,0,0,0,2.546-2.933c5.512-8.819,10.891-16.987,15.882-27.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8217",
    "data-name": "Group 8217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8216",
    "data-name": "Group 8216",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8215",
    "data-name": "Group 8215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5855",
    "data-name": "Path 5855",
    d: "M241.335,384.409c-5.98-3.324-12.859-4.751-19.689-5.164a29.9,29.9,0,0,0-7.958.7c-3.569.75-7.675,2.554-8.456,5.119,8.21-2.572,20.294-.878,28.7.959a30.828,30.828,0,0,1,20.093,14.236A28.666,28.666,0,0,0,241.335,384.409Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8219",
    "data-name": "Group 8219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8218",
    "data-name": "Group 8218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5856",
    "data-name": "Path 5856",
    d: "M280.581,283.386a6.32,6.32,0,0,1-.4-1.252c-.214-.815-.562-1.983-1.034-3.41a55.051,55.051,0,0,0-11.816-20.081c-1.018-1.106-1.871-1.978-2.479-2.56a6.424,6.424,0,0,1-.9-.956,6.4,6.4,0,0,1,1.038.807c.652.538,1.549,1.375,2.609,2.456a49.561,49.561,0,0,1,11.9,20.223c.43,1.451.726,2.641.88,3.473A6.421,6.421,0,0,1,280.581,283.386Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8238",
    "data-name": "Group 8238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8223",
    "data-name": "Group 8223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8222",
    "data-name": "Group 8222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5857",
    "data-name": "Path 5857",
    d: "M296.55,459.233,248.1,342.34c-2.211-5.335.563-9.659,6.195-9.659h9.748c3.978,0,6.688-2.191,6.944-5.612l.323-4.3c.258-3.42,2.973-5.611,6.955-5.611h46.318a16.215,16.215,0,0,1,10.726,4.745l3.759,3.643a16.2,16.2,0,0,0,10.717,4.745h58.993c5.633,0,11.941,4.324,14.089,9.659L470.9,459.233Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8225",
    "data-name": "Group 8225",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8224",
    "data-name": "Group 8224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5858",
    "data-name": "Path 5858",
    d: "M296.55,459.233,248.1,342.34c-2.211-5.335.563-9.659,6.195-9.659h9.748c3.978,0,6.688-2.191,6.944-5.612l.323-4.3c.258-3.42,2.973-5.611,6.955-5.611h46.318a16.215,16.215,0,0,1,10.726,4.745l3.759,3.643a16.2,16.2,0,0,0,10.717,4.745h58.993c5.633,0,11.941,4.324,14.089,9.659L470.9,459.233Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8226",
    "data-name": "Group 8226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5859",
    "data-name": "Path 5859",
    d: "M288.543,419.534,270.27,348.885c-1.2-4.652,1.844-9.319,6.084-9.319H419.581a6.532,6.532,0,0,1,6.1,5.262l26.6,106.338c1.168,4.669-.7,7.47-4.943,7.416l-144.108.045a6.536,6.536,0,0,1-6.019-5.22Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8232",
    "data-name": "Group 8232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8227",
    "data-name": "Group 8227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5860",
    "data-name": "Path 5860",
    d: "M298.441,456.036l-7.784-111.257a6.824,6.824,0,0,1,6.806-7.3h148.4V456.036Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8231",
    "data-name": "Group 8231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8230",
    "data-name": "Group 8230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8229",
    "data-name": "Group 8229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8228",
    "data-name": "Group 8228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5861",
    "data-name": "Path 5861",
    d: "M296.78,458.582l17.655-114.7a8.219,8.219,0,0,1,8.069-6.406H472.628a8.115,8.115,0,0,1,7.579,11.3L447.791,453.749Z",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8237",
    "data-name": "Group 8237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8236",
    "data-name": "Group 8236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8235",
    "data-name": "Group 8235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8234",
    "data-name": "Group 8234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8233",
    "data-name": "Group 8233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5862",
    "data-name": "Path 5862",
    d: "M296.55,459.182,332.959,351.76a10.777,10.777,0,0,1,10.126-7.468H497.849c4.988,0,8.505,5.105,6.912,10.035L470.9,459.233Z",
    fill: "#ff725e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8240",
    "data-name": "Group 8240",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8239",
    "data-name": "Group 8239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5863",
    "data-name": "Path 5863",
    d: "M371.378,441.2s-5.842.266-8.537.45a79.514,79.514,0,0,1-37.6-6.67c-3.642-1.623-7.494-3.913-8.6-7.745-1.234-4.291,1.546-8.757,4.934-11.665s7.508-4.98,10.45-8.339,4.334-8.795,1.436-12.192l-.8.587c-2.1,5.3-7.925,7.863-12.753,10.9a45,45,0,0,0-18.9,24.7c-1.7,5.562-2.153,12.049,1.219,16.787,2.392,3.361,6.309,5.272,10.177,6.706,11.708,4.342,24.222,4.505,36.709,4.519,3.946.005,16.054-.162,16.054-.162,3.807-1.036,5.064-3.018,7.355-6.229C374.628,449.893,374.168,443.508,371.378,441.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8249",
    "data-name": "Group 8249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8242",
    "data-name": "Group 8242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8241",
    "data-name": "Group 8241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5864",
    "data-name": "Path 5864",
    d: "M371.378,441.2l-40.365-6.069-15.671-9.017a7.074,7.074,0,0,1-3.6-5.693l-.006-.133a7.158,7.158,0,0,1,4.435-6.832c4.973-2.094,12.848-4.881,16.207-10.765,4.828-8.457,0-10.212,0-10.212l-33.708,13.475-23.861,16.24-4.8,27.079L303.3,460.144s37.1,2.091,47.335.942,10.237-5.916,10.237-5.916c1.9-.594,5.744-3.969,5.743-7.114,4.967-4.66,4.764-6.859,4.764-6.859",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8245",
    "data-name": "Group 8245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8244",
    "data-name": "Group 8244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8243",
    "data-name": "Group 8243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5865",
    "data-name": "Path 5865",
    d: "M319.75,452.852a8.017,8.017,0,0,1,1.663.317c1.054.257,2.589.6,4.49.975a94.935,94.935,0,0,0,30.126,1.175c1.925-.23,3.481-.448,4.552-.622a8.017,8.017,0,0,1,1.683-.187,8.076,8.076,0,0,1-1.633.45c-1.06.255-2.61.547-4.537.84a81.973,81.973,0,0,1-30.293-1.181c-1.9-.442-3.422-.855-4.458-1.192A7.99,7.99,0,0,1,319.75,452.852Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8248",
    "data-name": "Group 8248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8247",
    "data-name": "Group 8247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8246",
    "data-name": "Group 8246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5866",
    "data-name": "Path 5866",
    d: "M323.435,446.611a8.357,8.357,0,0,1,1.689.322c1.07.26,2.629.6,4.561.97a97.918,97.918,0,0,0,15.258,1.686,103.578,103.578,0,0,0,15.342-.7c1.954-.235,3.533-.46,4.621-.636a8.335,8.335,0,0,1,1.708-.193,8.249,8.249,0,0,1-1.659.456c-1.075.258-2.649.556-4.6.855a86.925,86.925,0,0,1-15.428.908,82.815,82.815,0,0,1-15.335-1.9c-1.931-.434-3.479-.847-4.533-1.186A8.229,8.229,0,0,1,323.435,446.611Z",
    fill: "#eb996e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8311",
    "data-name": "Group 8311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8295",
    "data-name": "Group 8295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8280",
    "data-name": "Group 8280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8267",
    "data-name": "Group 8267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8266",
    "data-name": "Group 8266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8255",
    "data-name": "Group 8255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8254",
    "data-name": "Group 8254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8253",
    "data-name": "Group 8253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8252",
    "data-name": "Group 8252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8251",
    "data-name": "Group 8251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5867",
    "data-name": "Path 5867",
    d: "M561.5,297.308l-71.719,14.165a9.147,9.147,0,0,1-10.746-7.2L459.431,205a9.147,9.147,0,0,1,7.2-10.746l45.484-8.984,42.376,29.335L568.7,286.562A9.147,9.147,0,0,1,561.5,297.308Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8260",
    "data-name": "Group 8260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8259",
    "data-name": "Group 8259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8258",
    "data-name": "Group 8258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8257",
    "data-name": "Group 8257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8256",
    "data-name": "Group 8256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5868",
    "data-name": "Path 5868",
    d: "M512.116,185.273l5.518,27.939a8.507,8.507,0,0,0,9.994,6.7l26.864-5.3Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8265",
    "data-name": "Group 8265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8264",
    "data-name": "Group 8264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8263",
    "data-name": "Group 8263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8262",
    "data-name": "Group 8262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8261",
    "data-name": "Group 8261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5869",
    "data-name": "Path 5869",
    d: "M518.485,215.591s.985,6.846,9.139,7.55a8.859,8.859,0,0,0,.922.024c3.632-.066,27.534-.519,27.429-1.049-.113-.574-1.483-7.508-1.483-7.508l-26.863,5.306S520.876,221.01,518.485,215.591Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8273",
    "data-name": "Group 8273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8272",
    "data-name": "Group 8272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8271",
    "data-name": "Group 8271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8270",
    "data-name": "Group 8270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8269",
    "data-name": "Group 8269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8268",
    "data-name": "Group 8268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5870",
    "data-name": "Path 5870",
    d: "M561.5,297.308s.13-.044.387-.114a7.809,7.809,0,0,0,1.13-.369,9.151,9.151,0,0,0,3.7-2.7,9.058,9.058,0,0,0,1.971-6.975c-.524-2.906-1.238-6.253-1.975-10-2.99-15.021-7.269-36.521-12.438-62.5l.089.136-42.394-29.308.19.039L485.92,190.71l-13.729,2.714-3.484.688a23.392,23.392,0,0,0-3.427.809,8.891,8.891,0,0,0-4.965,4.65,8.765,8.765,0,0,0-.72,4.754c.252,1.61.625,3.259.93,4.878q.963,4.875,1.912,9.683,1.9,9.615,3.735,18.932c2.446,12.412,4.8,24.384,7.053,35.79q1.684,8.555,3.281,16.667.8,4.053,1.571,7.985.386,1.965.767,3.9a20.91,20.91,0,0,0,.914,3.75,8.946,8.946,0,0,0,8.783,5.507,33.849,33.849,0,0,0,3.553-.6l13.541-2.657,40.868-7.988,11.117-2.146,2.893-.545c.653-.12.989-.168.989-.168s-.33.083-.979.22l-2.883.6-11.1,2.242-40.837,8.15-13.534,2.69a34.213,34.213,0,0,1-3.606.62,9.273,9.273,0,0,1-3.723-.533,9.385,9.385,0,0,1-5.485-5.218,21.3,21.3,0,0,1-.945-3.83q-.384-1.934-.773-3.9-.78-3.93-1.583-7.982-1.607-8.1-3.3-16.663c-2.257-11.4-4.626-23.374-7.083-35.784q-1.84-9.309-3.743-18.931l-1.913-9.682c-.308-1.636-.673-3.232-.937-4.914a9.292,9.292,0,0,1,.762-5.034,9.411,9.411,0,0,1,5.257-4.922,23.728,23.728,0,0,1,3.51-.832l3.483-.688,13.73-2.71,26.248-5.176.1-.02.087.06,42.358,29.362.073.05.017.086c5.094,25.991,9.311,47.5,12.257,62.534.719,3.76,1.412,7.093,1.92,10.027a9.18,9.18,0,0,1-2.061,7.084,9.081,9.081,0,0,1-3.779,2.677,6.829,6.829,0,0,1-1.146.338C561.636,297.286,561.5,297.308,561.5,297.308Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8279",
    "data-name": "Group 8279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8278",
    "data-name": "Group 8278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8277",
    "data-name": "Group 8277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8276",
    "data-name": "Group 8276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8275",
    "data-name": "Group 8275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8274",
    "data-name": "Group 8274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5871",
    "data-name": "Path 5871",
    d: "M554.492,214.608a3.5,3.5,0,0,1-.679.188l-1.97.438-7.261,1.518L533.8,218.936l-6.38,1.262a8.78,8.78,0,0,1-9.135-4.431,10.14,10.14,0,0,1-1.065-3.333c-.432-2.21-.848-4.343-1.244-6.377-.78-4.053-1.483-7.711-2.077-10.8-.565-3.035-1.025-5.511-1.356-7.292-.142-.822-.256-1.482-.343-1.988a3.526,3.526,0,0,1-.085-.7,3.566,3.566,0,0,1,.188.68c.111.5.257,1.155.438,1.969.371,1.773.887,4.238,1.519,7.26l2.186,10.782c.407,2.032.833,4.163,1.274,6.371a9.642,9.642,0,0,0,1.02,3.183,8.293,8.293,0,0,0,8.6,4.177l6.371-1.229,10.8-2.075,7.293-1.355,1.988-.343A3.637,3.637,0,0,1,554.492,214.608Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8282",
    "data-name": "Group 8282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8281",
    "data-name": "Group 8281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5872",
    "data-name": "Path 5872",
    d: "M515.685,210.471c.028.141-8.421,1.929-18.868,3.992s-18.943,3.623-18.971,3.482,8.419-1.928,18.87-3.993S515.657,210.33,515.685,210.471Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8284",
    "data-name": "Group 8284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8283",
    "data-name": "Group 8283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    "data-name": "Path 5873",
    d: "M536.391,220.862c.027.141-12.441,2.723-27.845,5.765s-27.92,5.4-27.948,5.255,12.438-2.722,27.847-5.766S536.363,220.721,536.391,220.862Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8286",
    "data-name": "Group 8286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8285",
    "data-name": "Group 8285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5874",
    "data-name": "Path 5874",
    d: "M539.143,234.8c.028.141-12.44,2.723-27.844,5.765s-27.92,5.4-27.948,5.255,12.437-2.722,27.847-5.766S539.115,234.658,539.143,234.8Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8288",
    "data-name": "Group 8288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8287",
    "data-name": "Group 8287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5875",
    "data-name": "Path 5875",
    d: "M486.1,259.756c-.028-.142,12.44-2.723,27.844-5.765s27.92-5.4,27.948-5.255-12.438,2.722-27.847,5.766S486.132,259.9,486.1,259.756Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8290",
    "data-name": "Group 8290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8289",
    "data-name": "Group 8289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M544.649,262.673c.027.141-12.441,2.722-27.845,5.765s-27.92,5.4-27.948,5.254,12.438-2.722,27.847-5.765S544.621,262.532,544.649,262.673Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8292",
    "data-name": "Group 8292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8291",
    "data-name": "Group 8291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5877",
    "data-name": "Path 5877",
    d: "M547.4,276.61c.028.141-12.44,2.722-27.844,5.765s-27.92,5.395-27.948,5.254,12.437-2.722,27.847-5.765S547.373,276.469,547.4,276.61Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8293",
    "data-name": "Group 8293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    d: "M4.221,0H57.871a4.222,4.222,0,0,1,4.222,4.222V23.678A4.222,4.222,0,0,1,57.871,27.9H4.222A4.222,4.222,0,0,1,0,23.678V4.221A4.221,4.221,0,0,1,4.221,0Z",
    transform: "matrix(0.981, -0.194, 0.194, 0.981, 455.499, 269.702)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8294",
    "data-name": "Group 8294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5878",
    "data-name": "Path 5878",
    d: "M472.187,275.658l4.7-.927c3.385-.669,6.107.912,6.725,4.044s-1.3,5.63-4.682,6.3l-4.7.927Zm6.235,7.473a3.273,3.273,0,1,0-1.266-6.412l-2.187.432,1.267,6.412Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5879",
    "data-name": "Path 5879",
    d: "M484.759,278.548a5.778,5.778,0,1,1,6.716,4.231A5.458,5.458,0,0,1,484.759,278.548Zm8.895-1.757a3.3,3.3,0,1,0-2.582,3.949A3.217,3.217,0,0,0,493.654,276.791Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5880",
    "data-name": "Path 5880",
    d: "M497.227,276.085a5.805,5.805,0,0,1,9.176-5.465l-1.257,1.721a3.391,3.391,0,0,0-2.84-.7,3.373,3.373,0,1,0,1.308,6.619,3.363,3.363,0,0,0,2.358-1.739l1.818,1.114a5.8,5.8,0,0,1-10.563-1.553Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8310",
    "data-name": "Group 8310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8297",
    "data-name": "Group 8297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8296",
    "data-name": "Group 8296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5881",
    "data-name": "Path 5881",
    d: "M550.221,223.437s5.3-6.706,9.376-2.956,2.9,5.679-.976,11.607c0,0,8.658-.455,5.882,8.438,0,0,8.628-.954,7.8,6.324,0,0,6.515,6.375,3.127,10.484s-15.676,11.528-18.78,10.252-3.128-5.672-3.128-5.672-3.692-1.663-4.711-3.608.731-4.671.731-4.671-3.113-3.18-3.884-4.068.422-5.013.422-5.013l4.97-4.821s-6.843,2.973-8.269,1.839-3.033-2.114-1.507-4.183,6.954-6.7,6.954-6.7Z",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8300",
    "data-name": "Group 8300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8299",
    "data-name": "Group 8299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8298",
    "data-name": "Group 8298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5882",
    "data-name": "Path 5882",
    d: "M554.212,262.422a23.6,23.6,0,0,1,2.242-2.723,26.193,26.193,0,0,1,6.321-5.79,60.989,60.989,0,0,0,7.1-4.567,33.747,33.747,0,0,0,2.422-2.492,6.325,6.325,0,0,1-2.033,2.926c-1.584,1.58-4.25,3.114-7.053,4.83a31.793,31.793,0,0,0-6.332,5.487A11.132,11.132,0,0,1,554.212,262.422Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8303",
    "data-name": "Group 8303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8302",
    "data-name": "Group 8302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8301",
    "data-name": "Group 8301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5883",
    "data-name": "Path 5883",
    d: "M549.419,254.917c-.161-.161,3.019-3.6,7.1-7.669,2.05-2.005,3.807-3.955,5.32-5.148a6.4,6.4,0,0,1,2.663-1.573c.059.111-.933.714-2.279,2.012-1.369,1.264-3.049,3.264-5.122,5.293C553.02,251.906,549.58,255.078,549.419,254.917Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8306",
    "data-name": "Group 8306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8305",
    "data-name": "Group 8305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8304",
    "data-name": "Group 8304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5884",
    "data-name": "Path 5884",
    d: "M551.048,239.733c-.163-.206,1.8-1.765,3.981-3.842,2.217-2.064,3.3-4.267,3.508-4.187.235.052-.607,2.612-2.932,4.776C553.337,238.638,551.163,239.886,551.048,239.733Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8309",
    "data-name": "Group 8309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8308",
    "data-name": "Group 8308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8307",
    "data-name": "Group 8307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5885",
    "data-name": "Path 5885",
    d: "M550.223,223.413a2.181,2.181,0,0,1-.088.5c-.089.371-.2.835-.341,1.413-.336,1.3-.8,3.1-1.393,5.393l-.013.051-.044.038c-1,.88-2.122,1.889-3.336,3.032a29.5,29.5,0,0,0-3.693,3.946,2.062,2.062,0,0,0-.376,1.253,1.983,1.983,0,0,0,.667,1.169,13.353,13.353,0,0,0,1.219,1.007,1.844,1.844,0,0,0,1.379.274,26.45,26.45,0,0,0,6.712-2.082l1.6-.662-1.236,1.208-4.952,4.839.075-.106a6.319,6.319,0,0,0-.255,5.034,14.045,14.045,0,0,0,3.919,3.993l.337.253-.271.32c-1.082,1.277-1.848,3.3-.434,4.543a18.365,18.365,0,0,0,4.692,3.21l-.582.323.008-.1s0-.045,0-.027v.007c.1.12-.231-.287.237.352,1.116-.527.323-.217.567-.3h0v.005l-.009.19,0,.4a7.691,7.691,0,0,0,.075.815,6.358,6.358,0,0,0,.43,1.568,4.181,4.181,0,0,0,.879,1.318,2.474,2.474,0,0,0,1.285.737,7.838,7.838,0,0,0,3.272-.645,29.1,29.1,0,0,0,3.251-1.462,53.4,53.4,0,0,0,5.784-3.5,33.71,33.71,0,0,0,5.06-4.152,4.1,4.1,0,0,0,1.314-2.6,6.334,6.334,0,0,0-.533-2.914,16.567,16.567,0,0,0-3.4-4.948l-.123-.129.009-.191a6.231,6.231,0,0,0-.293-2.844,4.219,4.219,0,0,0-1.743-2.06,9.306,9.306,0,0,0-5.339-1.022l-.5.031.119-.491c.131-.541.285-1.074.4-1.606a9,9,0,0,0,.124-1.591,4.409,4.409,0,0,0-.893-2.815c-1.224-1.55-3.364-2.021-5.154-2.018h-.58l.31-.47a48.294,48.294,0,0,0,2.789-4.548,6.687,6.687,0,0,0,.708-2.253,3.687,3.687,0,0,0-.444-2.1,9.37,9.37,0,0,0-2.722-2.958,4,4,0,0,0-3.238-.33,10.825,10.825,0,0,0-4.027,2.521c-.409.372-.7.679-.9.881a1.9,1.9,0,0,1-.312.3,1.391,1.391,0,0,1,.245-.358,12.309,12.309,0,0,1,.845-.948,13.259,13.259,0,0,1,1.552-1.369,8.223,8.223,0,0,1,2.5-1.349,4.349,4.349,0,0,1,3.544.3l.829.606.75.718a8.56,8.56,0,0,1,1.359,1.76,4.191,4.191,0,0,1,.534,2.368,7.178,7.178,0,0,1-.73,2.448,47.611,47.611,0,0,1-2.774,4.643l-.27-.469a9.031,9.031,0,0,1,3.018.431,5.574,5.574,0,0,1,2.69,1.784,5.087,5.087,0,0,1,1.059,3.208,9.64,9.64,0,0,1-.123,1.726c-.113.566-.27,1.127-.407,1.7l-.378-.459a9.978,9.978,0,0,1,5.806,1.093,4.981,4.981,0,0,1,2.061,2.418,6.979,6.979,0,0,1,.354,3.209l-.113-.319a17.222,17.222,0,0,1,3.6,5.2,7.1,7.1,0,0,1,.6,3.295,5.1,5.1,0,0,1-.481,1.692,7.43,7.43,0,0,1-1.041,1.389,34.235,34.235,0,0,1-5.184,4.272,53.824,53.824,0,0,1-5.874,3.557,29.617,29.617,0,0,1-3.344,1.5,8.416,8.416,0,0,1-3.678.685,4.09,4.09,0,0,1-2.793-2.545,7.156,7.156,0,0,1-.484-1.772,8.55,8.55,0,0,1-.082-.9l0-.455.012-.239.005-.048,0-.013c.243-.089-.549.219.569-.31.47.635.135.23.238.353v.034l-.005.08-.01.117-.055.6-.528-.282a18.956,18.956,0,0,1-4.919-3.4,3.839,3.839,0,0,1-.843-1.35,3.186,3.186,0,0,1-.067-1.6,6.13,6.13,0,0,1,1.35-2.646l.066.573a14.612,14.612,0,0,1-4.137-4.285,5.254,5.254,0,0,1-.458-2.937,9.3,9.3,0,0,1,.729-2.738l.025-.058.051-.049,4.986-4.8.365.546a26.7,26.7,0,0,1-6.933,2.07,2.435,2.435,0,0,1-1.786-.415A13.788,13.788,0,0,1,541.2,240.6a2.526,2.526,0,0,1-.811-1.517,2.579,2.579,0,0,1,.474-1.587,28.856,28.856,0,0,1,3.837-3.992c1.24-1.127,2.383-2.116,3.408-2.976l-.057.088c.667-2.284,1.191-4.08,1.568-5.373l.427-1.379A1.884,1.884,0,0,1,550.223,223.413Z",
    fill: "#eb996e"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Files"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8357",
    "data-name": "Group 8357",
    transform: "translate(51.814 0.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8342",
    "data-name": "Group 8342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8329",
    "data-name": "Group 8329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8328",
    "data-name": "Group 8328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8317",
    "data-name": "Group 8317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8316",
    "data-name": "Group 8316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8315",
    "data-name": "Group 8315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8314",
    "data-name": "Group 8314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8313",
    "data-name": "Group 8313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5886",
    "data-name": "Path 5886",
    d: "M186.028,277.358h-61.7a7.721,7.721,0,0,1-7.72-7.721v-85.4a7.721,7.721,0,0,1,7.72-7.721h39.133l30.291,31.221v61.9A7.721,7.721,0,0,1,186.028,277.358Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8322",
    "data-name": "Group 8322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8321",
    "data-name": "Group 8321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8320",
    "data-name": "Group 8320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8319",
    "data-name": "Group 8319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8318",
    "data-name": "Group 8318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5887",
    "data-name": "Path 5887",
    d: "M163.457,176.512v24.037a7.181,7.181,0,0,0,7.179,7.181l23.112,0Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8327",
    "data-name": "Group 8327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8326",
    "data-name": "Group 8326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8325",
    "data-name": "Group 8325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8324",
    "data-name": "Group 8324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8323",
    "data-name": "Group 8323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5888",
    "data-name": "Path 5888",
    d: "M163.772,202.658s-.3,5.83,6.333,7.746a7.3,7.3,0,0,0,.759.171c3.018.54,22.884,4.074,22.884,3.617v-6.459H170.636S164.866,207.536,163.772,202.658Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8335",
    "data-name": "Group 8335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8334",
    "data-name": "Group 8334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8333",
    "data-name": "Group 8333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8332",
    "data-name": "Group 8332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8331",
    "data-name": "Group 8331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8330",
    "data-name": "Group 8330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5889",
    "data-name": "Path 5889",
    d: "M186.028,277.358c0-.036.462.01,1.333-.157a7.734,7.734,0,0,0,3.5-1.631,7.634,7.634,0,0,0,2.765-5.447c.039-2.49-.006-5.379,0-8.6-.022-12.931-.054-31.433-.092-53.785l.061.152-30.315-31.2.179.076-22.58.008-11.812,0h-3a19.849,19.849,0,0,0-2.964.109,7.464,7.464,0,0,0-4.845,3.022,7.359,7.359,0,0,0-1.366,3.8c-.055,1.369-.016,2.8-.028,4.189q0,4.192,0,8.33,0,8.271,0,16.287c-.005,10.678-.01,20.977-.015,30.789q-.006,7.359-.011,14.338,0,3.486-.006,6.869,0,1.691,0,3.354a17.629,17.629,0,0,0,.142,3.249,7.53,7.53,0,0,0,3.5,4.965,7.445,7.445,0,0,0,2.848,1.006,28.61,28.61,0,0,0,3.036.08l11.647.017,35.147.083,9.556.049,2.485.025c.56.009.847.027.847.027s-.287.018-.847.027l-2.485.025-9.556.049-35.147.083-11.647.017a28.793,28.793,0,0,1-3.091-.076,7.935,7.935,0,0,1-6.713-6.293,18.052,18.052,0,0,1-.157-3.333q0-1.664,0-3.354,0-3.383-.007-6.869,0-6.972-.011-14.338c0-9.812-.01-20.111-.015-30.789q0-8.009,0-16.287,0-4.136,0-8.33c.013-1.406-.028-2.783.028-4.226a7.892,7.892,0,0,1,1.462-4.064,7.984,7.984,0,0,1,5.184-3.232,20.036,20.036,0,0,1,3.049-.116h3l11.812,0,22.58.007h.106l.074.075L193.9,207.582l.062.063v.088c-.038,22.352-.07,40.854-.092,53.785-.02,3.231.006,6.1-.054,8.618a7.755,7.755,0,0,1-2.874,5.536,7.658,7.658,0,0,1-3.572,1.6,5.768,5.768,0,0,1-1.005.091C186.142,277.363,186.028,277.358,186.028,277.358Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8341",
    "data-name": "Group 8341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8340",
    "data-name": "Group 8340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8339",
    "data-name": "Group 8339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8338",
    "data-name": "Group 8338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8337",
    "data-name": "Group 8337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8336",
    "data-name": "Group 8336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5890",
    "data-name": "Path 5890",
    d: "M193.748,207.733a2.517,2.517,0,0,1-.594.052l-1.7.049-6.26.082-9.285.054-5.49,0a7.448,7.448,0,0,1-6.877-5.191,8.575,8.575,0,0,1-.338-2.946c.005-1.9.01-3.734.015-5.484.02-3.478.039-6.621.055-9.285.035-2.591.063-4.713.083-6.261l.049-1.7a2.542,2.542,0,0,1,.053-.594,2.587,2.587,0,0,1,.052.594c.013.445.029,1.009.049,1.7.02,1.548.048,3.67.083,6.261.016,2.664.035,5.807.056,9.285,0,1.75.009,3.584.015,5.484a8.114,8.114,0,0,0,.322,2.791,6.962,6.962,0,0,0,6.4,4.836l5.475.026,9.285.058,6.26.084,1.7.049A2.587,2.587,0,0,1,193.748,207.733Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8344",
    "data-name": "Group 8344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8343",
    "data-name": "Group 8343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5891",
    "data-name": "Path 5891",
    d: "M162.291,197.961c0,.144-7.288.26-16.277.26s-16.278-.116-16.278-.26,7.287-.261,16.278-.261S162.291,197.817,162.291,197.961Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8346",
    "data-name": "Group 8346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8345",
    "data-name": "Group 8345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5892",
    "data-name": "Path 5892",
    d: "M177.736,209.951c0,.144-10.746.261-24,.261s-24-.117-24-.261,10.744-.26,24-.26S177.736,209.807,177.736,209.951Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8348",
    "data-name": "Group 8348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8347",
    "data-name": "Group 8347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5893",
    "data-name": "Path 5893",
    d: "M177.736,221.942c0,.143-10.746.26-24,.26s-24-.117-24-.26,10.744-.261,24-.261S177.736,221.8,177.736,221.942Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8350",
    "data-name": "Group 8350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8349",
    "data-name": "Group 8349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5894",
    "data-name": "Path 5894",
    d: "M177.736,233.932c0,.144-10.746.261-24,.261s-24-.117-24-.261,10.744-.26,24-.26S177.736,233.788,177.736,233.932Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8352",
    "data-name": "Group 8352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8351",
    "data-name": "Group 8351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5895",
    "data-name": "Path 5895",
    d: "M177.736,245.923c0,.143-10.746.26-24,.26s-24-.117-24-.26,10.744-.261,24-.261S177.736,245.779,177.736,245.923Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8354",
    "data-name": "Group 8354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8353",
    "data-name": "Group 8353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5896",
    "data-name": "Path 5896",
    d: "M177.736,257.913c0,.144-10.746.26-24,.26s-24-.116-24-.26,10.744-.26,24-.26S177.736,257.769,177.736,257.913Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8355",
    "data-name": "Group 8355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    d: "M4.222,0H48.187a4.222,4.222,0,0,1,4.222,4.222V19.327a4.221,4.221,0,0,1-4.221,4.221H4.222A4.222,4.222,0,0,1,0,19.327V4.222A4.222,4.222,0,0,1,4.222,0Z",
    transform: "translate(102.768 237.163)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8356",
    "data-name": "Group 8356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5897",
    "data-name": "Path 5897",
    d: "M123.288,248.058c0,1.983-1.488,3.216-3.865,3.216h-1.792v2.453h-2.059v-8.9h3.851C121.8,244.83,123.288,246.063,123.288,248.058Zm-2.085,0c0-.978-.635-1.55-1.894-1.55h-1.678V249.6h1.678C120.568,249.6,121.2,249.024,121.2,248.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5898",
    "data-name": "Path 5898",
    d: "M124.748,244.83h4.042c2.911,0,4.906,1.754,4.906,4.449s-1.995,4.448-4.906,4.448h-4.042Zm3.94,7.206a2.763,2.763,0,1,0,0-5.516h-1.881v5.516Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5899",
    "data-name": "Path 5899",
    d: "M137.3,246.482v2.352h4.118v1.652H137.3v3.241h-2.059v-8.9h6.724v1.652Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8402",
    "data-name": "Group 8402",
    transform: "translate(421 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8387",
    "data-name": "Group 8387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8374",
    "data-name": "Group 8374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8373",
    "data-name": "Group 8373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8362",
    "data-name": "Group 8362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8361",
    "data-name": "Group 8361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8360",
    "data-name": "Group 8360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8359",
    "data-name": "Group 8359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8358",
    "data-name": "Group 8358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5900",
    "data-name": "Path 5900",
    d: "M146.726,418.087H85.682a7.638,7.638,0,0,1-7.638-7.638V325.956a7.638,7.638,0,0,1,7.637-7.639H124.4L154.364,349.2v61.244A7.638,7.638,0,0,1,146.726,418.087Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8367",
    "data-name": "Group 8367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8366",
    "data-name": "Group 8366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8365",
    "data-name": "Group 8365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8364",
    "data-name": "Group 8364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8363",
    "data-name": "Group 8363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5901",
    "data-name": "Path 5901",
    d: "M124.4,318.317V342.1a7.105,7.105,0,0,0,7.1,7.105l22.865,0Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8372",
    "data-name": "Group 8372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8371",
    "data-name": "Group 8371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8370",
    "data-name": "Group 8370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8369",
    "data-name": "Group 8369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8368",
    "data-name": "Group 8368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5902",
    "data-name": "Path 5902",
    d: "M124.708,344.184s-.3,5.768,6.265,7.664a7.364,7.364,0,0,0,.752.169c2.985.534,22.639,4.03,22.639,3.578V349.2H131.5S125.79,349.01,124.708,344.184Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8380",
    "data-name": "Group 8380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8379",
    "data-name": "Group 8379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8378",
    "data-name": "Group 8378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8377",
    "data-name": "Group 8377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8376",
    "data-name": "Group 8376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8375",
    "data-name": "Group 8375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5903",
    "data-name": "Path 5903",
    d: "M146.726,418.087c0-.036.458.009,1.319-.156a7.644,7.644,0,0,0,3.464-1.614,7.551,7.551,0,0,0,2.734-5.388c.039-2.463-.006-5.322,0-8.513-.022-12.794-.054-31.1-.092-53.211l.061.151-29.991-30.865.179.076-22.34.008-11.685,0H87.4a19.677,19.677,0,0,0-2.931.108,7.38,7.38,0,0,0-4.792,2.989,7.277,7.277,0,0,0-1.351,3.756c-.054,1.354-.015,2.769-.027,4.143v8.242l0,16.113-.015,30.461-.011,14.184-.007,6.8,0,3.318A17.516,17.516,0,0,0,78.4,411.9a7.433,7.433,0,0,0,6.274,5.9,28.274,28.274,0,0,0,3,.08L99.2,417.9l34.772.082,9.454.049,2.458.026c.554.009.838.027.838.027s-.284.018-.838.026l-2.458.026-9.454.049-34.772.083-11.522.017a28.469,28.469,0,0,1-3.059-.076,7.786,7.786,0,0,1-2.977-1.043,7.868,7.868,0,0,1-3.666-5.184,17.936,17.936,0,0,1-.156-3.3l0-3.318-.006-6.8L77.8,384.389l-.015-30.461,0-16.113v-8.242c.012-1.391-.029-2.753.027-4.18a7.813,7.813,0,0,1,1.447-4.022,7.9,7.9,0,0,1,5.131-3.2,19.859,19.859,0,0,1,3.016-.115h2.966l11.685,0,22.34.008h.106l.073.076c10.783,11.13,20.886,21.558,29.945,30.91l.062.063v.088c-.038,22.114-.07,40.417-.092,53.211-.02,3.2.006,6.038-.053,8.526a7.68,7.68,0,0,1-2.844,5.477A7.574,7.574,0,0,1,148.057,418a5.724,5.724,0,0,1-.994.09C146.839,418.092,146.726,418.087,146.726,418.087Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8386",
    "data-name": "Group 8386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8385",
    "data-name": "Group 8385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8384",
    "data-name": "Group 8384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8383",
    "data-name": "Group 8383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8382",
    "data-name": "Group 8382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8381",
    "data-name": "Group 8381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5904",
    "data-name": "Path 5904",
    d: "M154.364,349.2a2.462,2.462,0,0,1-.587.052l-1.684.049-6.194.082-9.186.054-5.431,0a7.37,7.37,0,0,1-6.806-5.137,8.5,8.5,0,0,1-.335-2.915c.005-1.88.01-3.7.015-5.426.021-3.441.04-6.55.056-9.186.034-2.563.062-4.661.082-6.194.02-.684.037-1.242.049-1.684a2.5,2.5,0,0,1,.053-.587,2.544,2.544,0,0,1,.052.587c.013.442.029,1,.049,1.684.021,1.533.049,3.631.083,6.194.016,2.636.035,5.745.056,9.186,0,1.731.01,3.546.015,5.426a8.03,8.03,0,0,0,.319,2.759,6.883,6.883,0,0,0,6.327,4.783l5.416.026,9.186.058,6.194.083,1.684.05A2.536,2.536,0,0,1,154.364,349.2Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8389",
    "data-name": "Group 8389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8388",
    "data-name": "Group 8388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5905",
    "data-name": "Path 5905",
    d: "M123.243,339.537c0,.144-7.211.26-16.1.26s-16.1-.116-16.1-.26,7.209-.26,16.1-.26S123.243,339.393,123.243,339.537Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8391",
    "data-name": "Group 8391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8390",
    "data-name": "Group 8390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5906",
    "data-name": "Path 5906",
    d: "M138.523,351.4c0,.144-10.631.261-23.743.261s-23.745-.117-23.745-.261,10.629-.26,23.745-.26S138.523,351.256,138.523,351.4Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8393",
    "data-name": "Group 8393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8392",
    "data-name": "Group 8392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5907",
    "data-name": "Path 5907",
    d: "M138.523,363.262c0,.144-10.631.26-23.743.26s-23.745-.116-23.745-.26,10.629-.26,23.745-.26S138.523,363.118,138.523,363.262Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8395",
    "data-name": "Group 8395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8394",
    "data-name": "Group 8394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5908",
    "data-name": "Path 5908",
    d: "M138.523,375.124c0,.144-10.631.261-23.743.261s-23.745-.117-23.745-.261,10.629-.26,23.745-.26S138.523,374.981,138.523,375.124Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8397",
    "data-name": "Group 8397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8396",
    "data-name": "Group 8396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5909",
    "data-name": "Path 5909",
    d: "M138.523,386.987c0,.144-10.631.26-23.743.26s-23.745-.116-23.745-.26,10.629-.26,23.745-.26S138.523,386.843,138.523,386.987Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8399",
    "data-name": "Group 8399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8398",
    "data-name": "Group 8398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5910",
    "data-name": "Path 5910",
    d: "M138.523,398.849c0,.144-10.631.261-23.743.261s-23.745-.117-23.745-.261,10.629-.26,23.745-.26S138.523,398.706,138.523,398.849Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8400",
    "data-name": "Group 8400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    d: "M4.221,0H47.627a4.221,4.221,0,0,1,4.221,4.221V19.075A4.222,4.222,0,0,1,47.627,23.3H4.222A4.222,4.222,0,0,1,0,19.075V4.221A4.221,4.221,0,0,1,4.221,0Z",
    transform: "translate(64.355 378.321)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8401",
    "data-name": "Group 8401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5911",
    "data-name": "Path 5911",
    d: "M84.652,389.105c0,1.961-1.471,3.18-3.822,3.18H79.057v2.427H77.02v-8.8h3.81C83.181,385.911,84.652,387.13,84.652,389.105Zm-2.063,0c0-.969-.628-1.534-1.873-1.534H79.057v3.055h1.659C81.961,390.626,82.589,390.06,82.589,389.105Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5912",
    "data-name": "Path 5912",
    d: "M93.729,389.105c0,1.961-1.471,3.18-3.822,3.18H88.134v2.427H86.1v-8.8h3.81C92.258,385.911,93.729,387.13,93.729,389.105Zm-2.061,0c0-.969-.629-1.534-1.874-1.534h-1.66v3.055h1.66C91.039,390.626,91.668,390.06,91.668,389.105Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5913",
    "data-name": "Path 5913",
    d: "M96.759,387.571H93.943v-1.66h7.67v1.66H98.8v7.141H96.759Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8447",
    "data-name": "Group 8447",
    transform: "translate(-28.783 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8432",
    "data-name": "Group 8432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8419",
    "data-name": "Group 8419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8418",
    "data-name": "Group 8418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8407",
    "data-name": "Group 8407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8406",
    "data-name": "Group 8406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8405",
    "data-name": "Group 8405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8404",
    "data-name": "Group 8404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8403",
    "data-name": "Group 8403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5914",
    "data-name": "Path 5914",
    d: "M266.756,176.719H206.1a7.588,7.588,0,0,1-7.589-7.589V85.176a7.59,7.59,0,0,1,7.589-7.59h38.468l29.777,30.691V169.13A7.59,7.59,0,0,1,266.756,176.719Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8412",
    "data-name": "Group 8412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8411",
    "data-name": "Group 8411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8410",
    "data-name": "Group 8410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8409",
    "data-name": "Group 8409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8408",
    "data-name": "Group 8408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5915",
    "data-name": "Path 5915",
    d: "M244.569,77.586v23.628a7.057,7.057,0,0,0,7.057,7.059l22.72,0Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8417",
    "data-name": "Group 8417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8416",
    "data-name": "Group 8416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8415",
    "data-name": "Group 8415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8414",
    "data-name": "Group 8414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8413",
    "data-name": "Group 8413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5916",
    "data-name": "Path 5916",
    d: "M244.879,103.288s-.3,5.731,6.225,7.615a7.606,7.606,0,0,0,.747.168c2.966.53,22.5,4,22.5,3.555v-6.349h-22.72S245.954,108.083,244.879,103.288Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8425",
    "data-name": "Group 8425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8424",
    "data-name": "Group 8424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8423",
    "data-name": "Group 8423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8422",
    "data-name": "Group 8422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8421",
    "data-name": "Group 8421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8420",
    "data-name": "Group 8420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M266.756,176.719c0-.035.455.01,1.311-.154a7.6,7.6,0,0,0,3.441-1.6,7.5,7.5,0,0,0,2.717-5.353c.038-2.448-.006-5.288-.005-8.46-.022-12.712-.054-30.9-.092-52.871l.061.151L244.39,77.76l.178.076-22.2.008-11.611,0h-2.946a19.433,19.433,0,0,0-2.913.107,7.331,7.331,0,0,0-4.76,2.969,7.227,7.227,0,0,0-1.342,3.731c-.053,1.345-.015,2.751-.027,4.117q0,4.124,0,8.189,0,8.131,0,16.011c-.005,10.5-.01,20.621-.015,30.266q-.006,7.233-.011,14.094,0,3.428-.006,6.752,0,1.662,0,3.3a17.463,17.463,0,0,0,.14,3.193,7.4,7.4,0,0,0,3.435,4.878,7.32,7.32,0,0,0,2.8.988,28.157,28.157,0,0,0,2.984.079l11.45.017,34.55.083,9.393.049,2.443.026c.55.009.832.026.832.026s-.282.018-.832.027l-2.443.026-9.393.049-34.55.082-11.45.017a28.1,28.1,0,0,1-3.039-.075,7.748,7.748,0,0,1-2.959-1.036,7.827,7.827,0,0,1-3.643-5.152,17.711,17.711,0,0,1-.154-3.277q0-1.635,0-3.3,0-3.324-.006-6.752-.006-6.854-.011-14.094c-.005-9.645-.01-19.77-.015-30.266q0-7.874,0-16.011,0-4.065,0-8.189c.012-1.382-.028-2.735.028-4.153a7.75,7.75,0,0,1,1.437-4,7.855,7.855,0,0,1,5.1-3.179,19.751,19.751,0,0,1,3-.114h2.946l11.611,0,22.2.008h.106l.074.076L274.5,108.126l.061.063v.088c-.038,21.972-.07,40.159-.092,52.871-.02,3.177.006,6-.054,8.472a7.629,7.629,0,0,1-2.826,5.443,7.536,7.536,0,0,1-3.512,1.568,5.712,5.712,0,0,1-.988.088C266.869,176.725,266.756,176.719,266.756,176.719Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8431",
    "data-name": "Group 8431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8430",
    "data-name": "Group 8430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8429",
    "data-name": "Group 8429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8428",
    "data-name": "Group 8428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8427",
    "data-name": "Group 8427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8426",
    "data-name": "Group 8426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5918",
    "data-name": "Path 5918",
    d: "M274.346,108.277a2.509,2.509,0,0,1-.584.052l-1.673.049-6.154.082-9.128.054-5.4,0a7.326,7.326,0,0,1-6.764-5.106,8.488,8.488,0,0,1-.333-2.9c.006-1.868.011-3.671.016-5.391.021-3.419.039-6.508.055-9.128.035-2.545.063-4.63.083-6.154.02-.679.036-1.233.049-1.673a2.459,2.459,0,0,1,.053-.583,2.5,2.5,0,0,1,.052.583c.013.44.029.994.049,1.673.02,1.524.048,3.609.083,6.154.016,2.62.035,5.709.056,9.128,0,1.721.009,3.523.015,5.391a7.953,7.953,0,0,0,.317,2.742,6.836,6.836,0,0,0,6.284,4.751l5.382.026,9.128.058,6.154.083,1.673.049A2.464,2.464,0,0,1,274.346,108.277Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8434",
    "data-name": "Group 8434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8433",
    "data-name": "Group 8433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5919",
    "data-name": "Path 5919",
    d: "M243.423,98.67c0,.144-7.165.261-16,.261s-16-.117-16-.261,7.163-.26,16-.26S243.423,98.527,243.423,98.67Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8436",
    "data-name": "Group 8436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8435",
    "data-name": "Group 8435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5920",
    "data-name": "Path 5920",
    d: "M258.606,110.457c0,.144-10.564.261-23.592.261s-23.593-.117-23.593-.261,10.561-.26,23.593-.26S258.606,110.313,258.606,110.457Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8438",
    "data-name": "Group 8438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8437",
    "data-name": "Group 8437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5921",
    "data-name": "Path 5921",
    d: "M258.606,122.244c0,.144-10.564.261-23.592.261s-23.593-.117-23.593-.261,10.561-.26,23.593-.26S258.606,122.1,258.606,122.244Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8440",
    "data-name": "Group 8440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8439",
    "data-name": "Group 8439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5922",
    "data-name": "Path 5922",
    d: "M258.606,134.031c0,.144-10.564.26-23.592.26s-23.593-.116-23.593-.26,10.561-.26,23.593-.26S258.606,133.887,258.606,134.031Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8442",
    "data-name": "Group 8442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8441",
    "data-name": "Group 8441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M258.606,145.818c0,.144-10.564.26-23.592.26s-23.593-.116-23.593-.26,10.561-.261,23.593-.261S258.606,145.674,258.606,145.818Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8444",
    "data-name": "Group 8444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8443",
    "data-name": "Group 8443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5924",
    "data-name": "Path 5924",
    d: "M258.606,157.6c0,.143-10.564.26-23.592.26s-23.593-.117-23.593-.26,10.561-.261,23.593-.261S258.606,157.461,258.606,157.6Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8445",
    "data-name": "Group 8445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    d: "M4.221,0H47.3a4.221,4.221,0,0,1,4.221,4.221V18.927A4.221,4.221,0,0,1,47.3,23.148H4.222A4.222,4.222,0,0,1,0,18.927V4.221A4.221,4.221,0,0,1,4.221,0Z",
    transform: "translate(184.911 137.207)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8446",
    "data-name": "Group 8446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5925",
    "data-name": "Path 5925",
    d: "M203.015,153.482l-2.112-3.037-2.074,3.037H196.5l3.237-4.449-3.074-4.3h2.3l2.012,2.837,1.975-2.837h2.187l-3.05,4.224,3.262,4.524Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    d: "M206.149,144.734h2.024v7.1h4.387v1.65h-6.411Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M212.958,152.62l.687-1.525a5.147,5.147,0,0,0,2.886.912c1.2,0,1.688-.4,1.688-.937,0-1.637-5.087-.513-5.087-3.762,0-1.487,1.2-2.724,3.687-2.724a5.871,5.871,0,0,1,3.037.775l-.625,1.537a4.935,4.935,0,0,0-2.424-.688c-1.2,0-1.662.451-1.662,1,0,1.613,5.086.5,5.086,3.712,0,1.462-1.212,2.712-3.712,2.712A6.23,6.23,0,0,1,212.958,152.62Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8492",
    "data-name": "Group 8492",
    transform: "translate(-52 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8477",
    "data-name": "Group 8477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8464",
    "data-name": "Group 8464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8463",
    "data-name": "Group 8463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8452",
    "data-name": "Group 8452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8451",
    "data-name": "Group 8451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8450",
    "data-name": "Group 8450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8449",
    "data-name": "Group 8449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8448",
    "data-name": "Group 8448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    d: "M641.936,429.94H580.314a7.71,7.71,0,0,1-7.71-7.71V336.937a7.711,7.711,0,0,1,7.711-7.71h39.08l30.252,31.18v61.822A7.71,7.71,0,0,1,641.936,429.94Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8457",
    "data-name": "Group 8457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8456",
    "data-name": "Group 8456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8455",
    "data-name": "Group 8455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8454",
    "data-name": "Group 8454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8453",
    "data-name": "Group 8453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    d: "M619.394,329.227v24a7.172,7.172,0,0,0,7.17,7.172l23.082,0Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8462",
    "data-name": "Group 8462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8461",
    "data-name": "Group 8461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8460",
    "data-name": "Group 8460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8459",
    "data-name": "Group 8459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8458",
    "data-name": "Group 8458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    d: "M619.709,355.338s-.3,5.822,6.325,7.736a7.281,7.281,0,0,0,.758.171c3.014.539,22.854,4.068,22.854,3.612v-6.45H626.564S620.8,360.21,619.709,355.338Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8470",
    "data-name": "Group 8470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8469",
    "data-name": "Group 8469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8468",
    "data-name": "Group 8468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8467",
    "data-name": "Group 8467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8466",
    "data-name": "Group 8466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8465",
    "data-name": "Group 8465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5931",
    "data-name": "Path 5931",
    d: "M641.936,429.94c0-.036.462.01,1.331-.157a7.721,7.721,0,0,0,3.5-1.629,7.625,7.625,0,0,0,2.761-5.439c.039-2.487-.006-5.373,0-8.6-.023-12.913-.054-31.391-.093-53.713l.062.151c-9.159-9.426-19.374-19.938-30.275-31.158l.179.076-22.551.008-11.8,0h-2.993a19.657,19.657,0,0,0-2.96.109,7.457,7.457,0,0,0-4.839,3.017,7.361,7.361,0,0,0-1.364,3.793c-.054,1.367-.015,2.8-.027,4.183q0,4.188,0,8.32,0,8.26,0,16.265c-.006,10.664-.011,20.95-.015,30.749q-.006,7.348-.011,14.319,0,3.481-.007,6.859,0,1.689,0,3.351a17.754,17.754,0,0,0,.142,3.244,7.519,7.519,0,0,0,3.491,4.958,7.435,7.435,0,0,0,2.844,1,28.56,28.56,0,0,0,3.033.081l11.632.017,35.1.082,9.543.049,2.482.026c.559.009.846.027.846.027s-.287.018-.846.026l-2.482.026-9.543.049-35.1.083-11.632.017a28.72,28.72,0,0,1-3.087-.076,7.859,7.859,0,0,1-3-1.053,7.94,7.94,0,0,1-3.7-5.232,18.006,18.006,0,0,1-.158-3.328q0-1.662,0-3.351,0-3.377-.006-6.859-.006-6.963-.011-14.319c-.005-9.8-.01-20.085-.016-30.749q0-8,0-16.265,0-4.131,0-8.32c.013-1.4-.028-2.779.029-4.219a7.874,7.874,0,0,1,1.459-4.06,7.98,7.98,0,0,1,5.178-3.228,20.108,20.108,0,0,1,3.045-.115h2.993l11.8,0,22.551.008h.106l.073.076,30.229,31.2.061.064v.088c-.038,22.322-.07,40.8-.092,53.713-.02,3.228.006,6.1-.054,8.607a7.745,7.745,0,0,1-2.87,5.529,7.651,7.651,0,0,1-3.568,1.593,5.749,5.749,0,0,1-1,.091C642.05,429.945,641.936,429.94,641.936,429.94Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8476",
    "data-name": "Group 8476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8475",
    "data-name": "Group 8475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8474",
    "data-name": "Group 8474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8473",
    "data-name": "Group 8473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8472",
    "data-name": "Group 8472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8471",
    "data-name": "Group 8471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    d: "M649.646,360.407a2.587,2.587,0,0,1-.593.052l-1.7.048-6.252.082-9.273.055-5.483,0a7.44,7.44,0,0,1-6.868-5.184,8.6,8.6,0,0,1-.338-2.942c.005-1.9.01-3.729.015-5.477.021-3.474.04-6.612.056-9.273.034-2.587.062-4.706.083-6.252.02-.692.036-1.254.049-1.7a2.58,2.58,0,0,1,.052-.592,2.533,2.533,0,0,1,.053.592l.049,1.7c.02,1.546.048,3.664.082,6.252.016,2.661.035,5.8.056,9.273.005,1.748.01,3.579.015,5.477a8.117,8.117,0,0,0,.322,2.787,6.953,6.953,0,0,0,6.389,4.829l5.468.027,9.273.057,6.252.084,1.7.049A2.537,2.537,0,0,1,649.646,360.407Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8479",
    "data-name": "Group 8479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8478",
    "data-name": "Group 8478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5933",
    "data-name": "Path 5933",
    d: "M618.23,350.647c0,.144-7.279.26-16.255.26s-16.257-.116-16.257-.26,7.277-.26,16.257-.26S618.23,350.5,618.23,350.647Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8481",
    "data-name": "Group 8481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8480",
    "data-name": "Group 8480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5934",
    "data-name": "Path 5934",
    d: "M633.655,362.622c0,.143-10.732.26-23.967.26s-23.97-.117-23.97-.26,10.73-.261,23.97-.261S633.655,362.478,633.655,362.622Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8483",
    "data-name": "Group 8483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8482",
    "data-name": "Group 8482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    d: "M633.655,374.6c0,.144-10.732.261-23.967.261s-23.97-.117-23.97-.261,10.73-.26,23.97-.26S633.655,374.453,633.655,374.6Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8485",
    "data-name": "Group 8485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8484",
    "data-name": "Group 8484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5936",
    "data-name": "Path 5936",
    d: "M633.655,386.571c0,.144-10.732.26-23.967.261s-23.97-.117-23.97-.261,10.73-.26,23.97-.26S633.655,386.427,633.655,386.571Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8487",
    "data-name": "Group 8487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8486",
    "data-name": "Group 8486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5937",
    "data-name": "Path 5937",
    d: "M633.655,398.546c0,.144-10.732.26-23.967.26s-23.97-.116-23.97-.26,10.73-.261,23.97-.261S633.655,398.4,633.655,398.546Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8489",
    "data-name": "Group 8489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8488",
    "data-name": "Group 8488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5938",
    "data-name": "Path 5938",
    d: "M633.655,413.315c0,.144-10.732.26-23.967.26s-23.97-.116-23.97-.26,10.73-.261,23.97-.261S633.655,413.171,633.655,413.315Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8490",
    "data-name": "Group 8490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    d: "M4.222,0h43.9a4.221,4.221,0,0,1,4.221,4.221V19.3a4.222,4.222,0,0,1-4.222,4.222H4.221A4.221,4.221,0,0,1,0,19.3V4.222A4.222,4.222,0,0,1,4.222,0Z",
    transform: "translate(558.786 389.797)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8491",
    "data-name": "Group 8491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5939",
    "data-name": "Path 5939",
    d: "M564.849,397.466h4.037c2.908,0,4.9,1.752,4.9,4.443s-1.993,4.444-4.9,4.444h-4.037Zm3.936,7.2a2.759,2.759,0,1,0,0-5.509h-1.879v5.509Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    "data-name": "Path 5940",
    d: "M574.774,401.909a4.87,4.87,0,1,1,4.862,4.6A4.6,4.6,0,0,1,574.774,401.909Zm7.643,0a2.781,2.781,0,1,0-2.781,2.844A2.711,2.711,0,0,0,582.417,401.909Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    "data-name": "Path 5941",
    d: "M585.486,401.909a4.893,4.893,0,0,1,8.48-3.021l-1.32,1.219a2.858,2.858,0,0,0-2.234-1.041,2.843,2.843,0,1,0,0,5.687,2.833,2.833,0,0,0,2.234-1.053l1.32,1.218a4.885,4.885,0,0,1-8.48-3.009Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M600.769,406.353l-2.145-3.085-2.108,3.085h-2.361l3.288-4.52-3.123-4.367h2.336l2.044,2.882,2.006-2.882h2.221l-3.1,4.291,3.313,4.6Z",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaddocument);
export default __webpack_public_path__ + "static/media/uploaddocument.9c60b7535b6e888c4d3d86cdcceeeb5f.svg";
export { ForwardRef as ReactComponent };